export interface Settings {
  masterVolume: number;
  effectsVolume: number;
  quality: "high" | "medium" | "low";
  cameraTilt: number;
  lookAhead: number;
  showPerformance: boolean;
  reducedMotion: boolean;
}
export const DEFAULT_SETTINGS: Settings = {
  masterVolume: 75,
  effectsVolume: 85,
  quality: "high",
  cameraTilt: 55,
  lookAhead: 1,
  showPerformance: false,
  reducedMotion: false,
};
export function loadSettings(): Settings {
  try {
    const value = JSON.parse(localStorage.getItem("warlock.settings") ?? "{}");
    return sanitizeSettings({ ...DEFAULT_SETTINGS, ...value });
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}
export function sanitizeSettings(s: Settings): Settings {
  const clamp = (n: number, min: number, max: number, fallback: number) =>
    Number.isFinite(Number(n))
      ? Math.min(max, Math.max(min, Number(n)))
      : fallback;
  return {
    masterVolume: clamp(s.masterVolume, 0, 100, 75),
    effectsVolume: clamp(s.effectsVolume, 0, 100, 85),
    quality: ["low", "medium", "high"].includes(s.quality) ? s.quality : "high",
    cameraTilt: clamp(s.cameraTilt, 45, 80, DEFAULT_SETTINGS.cameraTilt),
    lookAhead: clamp(s.lookAhead, 0, 1.5, 1),
    showPerformance: Boolean(s.showPerformance),
    reducedMotion: Boolean(s.reducedMotion),
  };
}
export function saveSettings(settings: Settings): void {
  try {
    localStorage.setItem(
      "warlock.settings",
      JSON.stringify(sanitizeSettings(settings)),
    );
  } catch {
    /* Private browsing can deny persistence. */
  }
}
